import { Typography, TypographyProps } from '@mui/material'
import { RhfStyleProps } from '../types/RhfStyleProps';
import { setTextProps, TextProps, setNormalWhiteSpace } from '../types/TextProps';

type Props = RhfStyleProps & TypographyProps & TextProps & {
  component?: any;
}

const Title = ({ sx, className, style, // RhfStyleProps
  text, bold, italic,// TextProps
  component, children, ...props }: Props
) => {

  style = setTextProps(style, bold, italic);

  setNormalWhiteSpace(props);

  if (text != null) {
    children = text;
  }

  return (
    <Typography variant={props.variant == null ? "h6" : props.variant}
      sx={{
        ...sx
      }}
      // sx={sx}
      className={className} style={style}
      {...props}
    >
      {children}
    </Typography>
  )
}

export default Title